export const languageData = [
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
  },
];

export const flags = {
  en: '/images/flag/icons8-usa.png',
};
